import xnuupClaimsLogo from "@/main/assets/images/product/xnuup-claims-logo.png";
import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";

const XNUUP_CLAIMS_BRAND_NAME = "Xnuup Claims";

export default function ClaimsSourceSeal() {
	return (
		<S.Seal id="id-refunds-seal-claimsSource">
			<span>{getTranslateByKey("information.by")}</span>
			<img src={xnuupClaimsLogo} alt={XNUUP_CLAIMS_BRAND_NAME} />
		</S.Seal>
	);
}
